const ko = {
  // Navigation
  nav_plan: '계획',
  nav_itinerary: '일정',
  nav_saved: '저장됨',

  // Header
  explore_photos: '사진 탐색',
  sign_in: '로그인',

  // Plan screen
  new_trip: '+ 새 여행',
  add_city_header: '도시 추가',
  city_placeholder: '도시 이름 입력…',
  add_cities_empty: '여행 계획을 시작하려면 도시를 추가하세요',
  dest_bangkok: '방콕', dest_paris: '파리', dest_london: '런던', dest_dubai: '두바이',
  dest_singapore: '싱가포르', dest_tokyo: '도쿄', dest_new_york: '뉴욕',
  dest_istanbul: '이스탄불', dest_kuala_lumpur: '쿠알라룸푸르', dest_seoul: '서울',
  hero_badge: 'AI 여행 계획',
  hero_title_line1: '다음 여행을,',
  hero_title_line2: '완벽하게 계획하세요.',
  hero_subtitle: '목적지를 탭하여 즉시 계획을 시작하세요',
  most_visited_label: '인기 여행지',
  popular_destinations: '인기 여행지',
  or_type_your_own: '또는 직접 입력',
  where_going_label: '어디로 가시나요?',
  expanding_region: (r) => `${r}의 주요 도시를 찾는 중…`,
  tap_to_explore: '— 탭하여 탐색',
  attraction_count: (n) => `명소 ${n}개`,
  show_less: '접기',
  read_more: '더 보기',
  more: '더 보기',
  less: '접기',
  no_attractions: '아직 추가된 명소가 없습니다',
  add_attraction_placeholder: (city) => `${city}에서 명소 추가…`,
  auto_add_title: '추천 명소 자동 추가',
  preferences_label: '관심사',
  all_types_label: '전체 유형',
  edit_interests: '관심사 편집…',
  plan_framing_msg: '마음에 드는 것은 남기고 나머지는 제거한 후 — 일일 계획을 생성하세요.',
  add_back: '복원',
  added_label: '추가됨',
  refresh_attractions: '명소 새로 고침',
  plan_multi_summary: (n, m) => `${n}개 도시 · ${m}곳`,
  filter_onboarding_msg: '명소 개인화',
  filter_onboarding_sub: '유형을 탭하여 필터링 — 해당 필터로 다시 생성합니다.',
  explore_nearby: '주변 명소 탐색',
  explore_nearby_sub: '여행 필수 명소의 사진 보기',
  finding_attractions: '명소 검색 중…',
  finding_attractions_1: 'AI에게 추천 받는 중…',
  finding_attractions_2: '인기 명소 찾는 중…',
  finding_attractions_3: '거의 다 됐어요…',
  generating_msg_1: '일정을 계획하는 중…',
  generating_msg_2: '최고의 명소를 찾는 중…',
  generating_msg_3: '여행 일정을 만드는 중…',
  view_itinerary: '일정 보기',
  generate_itinerary: '일정 생성',
  filterLabel: (label) => ({ 'All': '전체', 'Culture': '문화', 'Nature': '자연', 'Entertainment': '엔터테인먼트', 'Shopping': '쇼핑', 'Food & Drink': '음식·음료', 'Kids': '키즈', 'Seniors': '시니어' })[label] ?? label,

  // Itinerary screen
  rename: '이름 변경',
  days: (n) => `${n}일`,
  unsaved_dot: '저장되지 않은 변경 사항',
  share_itinerary: '일정 공유',
  copy: '복사',
  copied: '복사됨!',
  add_more_attractions: '명소 더 추가',
  search_city_placeholder: '도시 검색…',
  plus_city: '+ 도시',
  your_cities: '내 도시',
  unscheduled_count: (n) => `미배정 명소 (${n})`,
  drag_to_schedule: '날짜로 드래그하여 일정 배정',
  loading_details: '상세 정보 로드 중…',
  drag_here: '명소를 여기로 드래그',
  day_label: (n) => `${n}일차`,
  activity_count: (n) => `활동 ${n}개`,
  add_note: '+ 메모 추가',
  note_placeholder: '이 날의 메모 — 호텔 정보, 점심 장소, 알림 사항…',
  save_note: '메모 저장',
  cancel: '취소',
  continue_in_city: '기존 도시에서 계속하기',
  change_back: '← 변경',
  save: '저장',
  hotel_nights_label: '숙박 일수',
  hotel_name_label: '호텔 이름',
  restaurant_label: '식당 (선택사항)',
  search_hotel: '호텔 검색…',
  search_restaurant: '식당 검색…',
  searching: '검색 중…',
  address_label: '주소',
  time_label: '시간',
  duration_label: '소요 시간',
  notes_label: '메모',
  time_placeholder: '예: 오전 9:00',
  duration_placeholder: '예: 2시간',
  notes_placeholder: '예: 오후 3시 체크인, 수영장 전망 객실…',
  drag_to_reorder: '드래그하여 순서 변경',
  details: '상세 정보',
  edit: '편집',
  snip: 'Snip',
  remove: '삭제',
  move_to_day_picker: '날짜로 이동…',
  trip_start_date: '여행 시작일',
  itinerary_photo_sub: '도시 기반 AI 추천',
  itinerary_photo_cta: '여행의 숨겨진 보석을 찾아보세요',
  hotel: '호텔',
  meal_at: (restaurant) => `${restaurant}에서`,
  add_day: '날 추가',
  save_changes: '변경 사항 저장',
  saved_check: '저장됨 ✓',
  save_itinerary: '일정 저장',
  print_export: '🖨️ 인쇄 / PDF 내보내기',
  photos_details: '사진 및 상세 정보',

  // Saved screen
  snip_requires_account: '북마크를 저장하려면 무료 계정을 만드세요',
  sign_in_to_save:'여행을 저장하고 보려면 로그인하세요',
  sign_in_or_create: '로그인 또는 계정 만들기',
  snips: 'Snips',
  place_count: (n) => `${n}곳`,
  trips: '여행',
  loading_trips: '여행 로드 중…',
  no_saved_trips: '저장된 여행이 없습니다',
  add_to_plan: '계획에 추가',
  add_to_itinerary_btn: '일정에 추가',
  untitled_trip: '제목 없는 여행',
  open: '열기',

  // User menu
  signed_in_as: '로그인됨:',
  change_password: '비밀번호 변경',
  delete_user_menu: '사용자 삭제',
  sign_out: '로그아웃',

  // Load saved trip confirmation
  load_trip_confirm_title: '저장된 여행을 열까요?',
  load_trip_confirm_msg: '현재 계획이 삭제됩니다. 보관하려면 먼저 저장하세요.',

  // New trip confirmation
  unsaved_changes_title: '저장되지 않은 변경 사항',
  unsaved_changes_msg: '현재 여행에 저장되지 않은 변경 사항이 있습니다. 새 여행을 시작하시겠습니까?',
  discard_start_new: '삭제하고 새로 시작',
  new_trip_tab_title: '새 여행을 시작할까요?',
  new_trip_tab_msg: '현재 일정이 삭제됩니다. 보관하려면 먼저 저장하세요.',
  start_fresh: '새로 시작',

  // Auth modal
  create_account: '계정 만들기',
  email_placeholder: '이메일',
  password_placeholder: '비밀번호',
  i_agree_to: '동의합니다:',
  terms_of_service: '서비스 약관',
  privacy_policy: '개인정보처리방침',
  and: '및',
  no_account: '계정이 없으신가요? ',
  have_account: '이미 계정이 있으신가요? ',
  network_error: '네트워크 오류입니다. 다시 시도해주세요',
  err_email_exists: '이 이메일로 이미 계정이 존재합니다',
  err_invalid_credentials: '이메일 또는 비밀번호가 올바르지 않습니다',
  err_email_password_required: '이메일과 비밀번호를 입력해주세요',
  err_password_too_short: '비밀번호는 최소 6자 이상이어야 합니다',

  // Change password modal
  select_user: '사용자 선택…',
  new_password_placeholder: '새 비밀번호 (최소 6자)',
  update_password: '비밀번호 업데이트',
  password_updated: '비밀번호가 업데이트되었습니다',
  select_a_user: '사용자를 선택하세요',
  network_error_short: '네트워크 오류',

  // Delete user modal
  delete_user_trips: '사용자 및 여행 삭제',
  deleted_user: (email) => `${email} 삭제됨`,

  // Photo mode
  photo_loading_msg_1: '멋진 장소를 찾는 중…',
  photo_loading_msg_2: '사진과 세부 정보 확인 중…',
  photo_loading_msg_3: '거의 다 됐어요…',
  finding_places: '당신을 위한 장소를 찾는 중…',
  could_not_load_places: '장소를 로드할 수 없습니다',
  no_places: '표시할 장소가 없습니다',
  ai_error: 'AI 연결에 문제가 발생했습니다. 잠시 후 다시 시도하세요.',
  add_cities_suggestions: '개인화된 추천을 받으려면 도시를 추가하거나 장소를 저장하세요.',
  retry: '다시 시도',
  close: '닫기',
  finding_more_places: '더 많은 장소 탐색 중…',
  seen_it_all: '모두 보셨습니다!',
  photo_limit_msg: '이 세션의 50개 제한에 도달했습니다.',
  check_snips: 'Snips에서 저장된 장소를 확인하세요',
  photo_unavailable: '사진 없음',
  loading: '로드 중…',
  skip: '건너뛰기',
  plus_itinerary: '+ 일정',
  plus_plan: '+ 계획',
  photo_explore_title: '사진 탐색',
  photo_explore_sub: '시각적으로 장소 발견',
  swipe_lr: '왼쪽 또는 오른쪽으로 스와이프하여 건너뛰기',
  swipe_up: '위로 스와이프하여 건너뛰기',
  lets_go: '시작하기',
  tutorial_skip_desc: '이 장소 건너뛰기',
  tutorial_snip_desc: '나중에 확인할 Snips에 저장',
  tutorial_add_plan_desc: '플랜 탭에 추가',
  tutorial_add_itinerary_desc: '현재 일정에 바로 추가',
  tutorial_swipe_hint: '왼쪽, 오른쪽 또는 위로 스와이프해도 건너뛸 수 있습니다',

  // Footer
  copyright: '© 2026 Pazzie Inc.',
  terms: '약관',
  privacy: '개인정보',
  sample_itineraries: '샘플 여행 일정',
  browse_all_itineraries: '모두 보기 →',

  // Legal overlay
  back_to_app: '← SnipTrip으로 돌아가기',

  // Error boundary
  something_wrong: '오류가 발생했습니다',
  reload: '새로고침',

  // Print view
  copy_text: '텍스트 복사',
  copied_check: '✓ 복사됨',

  // Logic / computed strings
  copy_of: (name) => `${name} 복사본`,
  transportation: '교통',
  meal: '식사',

  // Chat mode
  chat_mode_link: '또는 AI 채팅으로 계획',
  chat_back: '← 빌드로 돌아가기',
  chat_input_placeholder: '메시지…',
  chat_error: '오류가 발생했습니다. 다시 시도하시겠어요?',
  chat_cities_count: (n) => `도시 ${n}개`,
  chat_places_count: (n) => `장소 ${n}개`,
  chat_no_cities: '아직 추가된 도시가 없습니다',

  // Discovery panels
  thinking_where: '어디로 안내할지 생각 중…',
  couldnt_load_suggestions: '추천을 로드할 수 없습니다. 다시 시도하시겠습니까?',
  back: '← 뒤로',
  no_new_suggestions: '새 추천이 없습니다 — 다른 질문을 해보세요.',
  back_to_questions: '← 질문으로 돌아가기',
  dismiss: '닫기',
  where_to_next_header: '다음에 어디로?',
  describe_place: '장소 유형 설명…',
  go: '이동',
  finding_ideas: '아이디어 탐색 중…',
  more_attractions: '더 많은 명소…',
  different_angle: '또는 다른 관점으로 탐색:',
  mood_for: '지금 어떤 기분인가요?',
  back_questions_short: '← 질문',
  describe_looking_for: '찾고 있는 것 설명…',
  where_to_next_trigger: (city) => city ? `+ ${city} 다음에 어디로?` : '+ 다음에 어디로?',
  what_else_trigger: (city) => `+ ${city} 근처에서 무엇을 더 추가할까요?`,
  day_chip_add_attraction: '명소 추가',
  day_chip_add_city: '근처 도시 추가',
  auto_populate_prompt: (city) => `${city}의 인기 명소를 자동 추천할까요?`,
  auto_populate_yes: '네, 추천해주세요',
  auto_populate_no: '아니요, 직접 추가할게요',
  or_discover_new: '+ 또는 새로운 곳 발견',
  select: '선택',
  add: '추가',
  freeform_cta: '기타 — 직접 설명하기',
};

export default ko;
